const content: { [key: string]: any } = {
  permissionRoleFeatureAssign: 'Assign Feature',
};

export default content;
